import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false, name: 'percent' })
export class PercentPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return parseInt(value, 0) + '%';
  }

  parse(value: any) {
    return parseInt(value, 0);
  }
}
